import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerIsUniqueContractOtherCostKeyGql } from '../createOtherQueries';

interface IUseIsUniqueContractOtherCode {
    contractId: number | undefined;
    code: string | undefined;
    isDirtyCode?: boolean;
    contractOtherCostId?: number | undefined;
}

const requestId = 'uerIsUniqueContractOtherCode';

export const useIsUniqueContractOtherCode = (props: IUseIsUniqueContractOtherCode) => {
    const dispatch = useDispatch();

    const { isDirtyCode, code, contractOtherCostId, contractId } = props;

    const variables = useMemo(
        () => (!!contractId && !!code?.length ? { contractId, contractOtherCostId, key: code?.trim() } : undefined),
        [code, contractId, contractOtherCostId],
    );

    const [data, , , request] = useRequest({
        requestId,
        query: uerIsUniqueContractOtherCostKeyGql,
        withEffect: false,
    });

    const result = useMemo(
        () => data?.uerIsUniqueContractOtherCostKey?.result,
        [data?.uerIsUniqueContractOtherCostKey?.result],
    );

    const debounceRequest = useDebounce(() => {
        if (code && isDirtyCode) {
            dispatch(request(variables));
        }
    }, 300);

    const [uerIsUniqueContractObjectNameReset] = useResetStoreData({ requestId });

    useEffect(() => {
        if (code?.length) {
            debounceRequest();
        }
    }, [code?.length, debounceRequest]);

    useEffect(
        () => () => {
            uerIsUniqueContractObjectNameReset(undefined);
        },
        [uerIsUniqueContractObjectNameReset],
    );

    return {
        isContractOtherCodeUnique: result ?? true,
    };
};
